"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  itemProp: true,
  itemScope: true,
  itemType: true,
  itemID: true,
  itemRef: true
};